const modulePages = [
	{
		id: 'm5-intro',
		isFacilitatorOnly: true,
		title: 'Intro til modulet',
		facilitatorInstructions: `Følg guiden. 
			<br /><br />Fortæl eleverne, hvad der skal ske på modul 5.`,
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'video-dancing-bear',
				type: 'video',
				text: 'Se video',
				videoId: 'xNSgmm9FX2s'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			},
		]
	},
	{
		id: 'm5-problem-solving',
		isFacilitatorOnly: true,
		title: 'Feedback',
		facilitatorInstructions: `Følg guiden trin for trin.
			<br/><br/>Eleverne fortæller, hvordan det er gået med basalplanen, og der gennemføres en fælles problemløsning.
			<br/><br/>Husk, at du selv er rollemodel.`,
		facilitatorText: `<strong>Hvad gik din basalplan ud på?</strong><br /><br />
			<strong>Hvordan er det gået med din basalplan?</strong><br/><br/>
			<strong>Mulighed for problemløsning.</strong><br /><br /><br />`,
		icons: ['plan-of-action', 'problem-solving'],
		slides: [
			{
				id: 'plan-of-action',
				type: 'image',
				text: 'Basalplansskema'
			},
			{
				id: 'problem-solving',
				type: 'image',
				text: 'Problemløsningsskema'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskasse'
			},
			{
			id: 'the-bad-circle',
			type: 'image', 
			text: 'Den svære cirkel'
			},
		
		]	
	},

	{
		id: 'm5-thought-traning',
		isFacilitatorOnly: false,
		title: 'Tanketræning: Brugbare og negative tanker',
		menuTitle: 'Tanketræning: Brugbare og negative tanker',
		facilitatorInstructions: `Følg guiden. <br/><br/>
		Eleverne skal komme med bud på brugbare og negative tanker. Deres svar kommer til syne på din skærm. Eleverne kan arbejde sammen i mindre grupper eller alene. <br/><br/>
		Når eleverne har givet deres bud, skal de vende negative tanker til brugbare tanker.`,
		facilitatorText: `Gå til <strong>www.basalsammen.dk.</strong> </br></br>
		Skriv koden i elevlogin. </br></br>`,
		groupInstructions: `<strong>Opgave 1:</strong> Hvad er brugbare tanker og negative tanker? Skriv et bud på en persons brugbare eller negative tanker. <br/> <br/>
		<strong>Opgave 2:</strong> Vend de negative tanker til brugbare tanker. `,
		groupText: null,
		icons: ['online-teaching'],
		slides: [
			{
				id: 'idea-round',
				type: 'image',
				text: 'Idérunde'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			}
		],
		minigames: [
			require('data/minigames/m5-thought-traps').minigameData
		]
	},
	{
		id: 'm5-active-break',
		isFacilitatorOnly: true,
		title: 'Aktiv pause',
		menuTitle: 'Aktiv pause',
		facilitatorInstructions: `Her kan du lægge en aktiv pause ind. Vælg én fra appendiks bagerst i Guide til facilitering eller find din egen. `,
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			}
		],
		minigames: []
	},
	{
		id: 'm5-sleep',
		isFacilitatorOnly: true,
		title: 'Søvn',
		facilitatorInstructions: `Følg guiden`,
		facilitatorText: null,
		groupText: null,
		icons: ['calm'],
		slides: [
			{
				id: 'video-me-and-my-sleep',
				type: 'video',
				text: 'Mig og min søvn',
				videoId: '8bIsZ7YlMuk'
			},
			{
				id: 'idea-round',
				type: 'image',
				text: 'Idérunde'
			}
		]
	},
	{
		id: 'm5-basal-plan',
		isFacilitatorOnly: true,
		title: 'Basalplan',
		menuTitle: 'Basalplan',
		facilitatorInstructions: `Følg guiden trin for trin. Eleverne udarbejder hver en basalplan. Husk, at du selv er rollemodel og også selv skal lave en basalplan.`,
		facilitatorText: `<strong>Opgave:</strong> <br/>
		Gå sammen i grupper og hjælp hinanden med at lave en basalplan. Fortæl jeres basalplaner til hinanden.`,
		groupText: null,
		icons: ['plan-of-action'],
		slides: [
			{
				id: 'plan-of-action',
				type: 'image',
				text: 'Basalplansskema'
			},
			{
				id: 'problem-solving',
				type: 'image',
				text: 'Problemløsningsskema'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			},
			{
				id: 'idea-round',
				type: 'image',
				text: 'Idérunde'
			}
		],
		minigames: []
	},
	{
		id: 'm5-finish',
		isFacilitatorOnly: true,
		title: 'Afrunding',
		menuTitle: 'Afrunding',
		facilitatorInstructions: `Følg guiden.`,
		facilitatorText: `<strong>Hvad har givet dig noget at tænke over?</strong> <br/><br/>
		<strong>Hvornår gør du noget meningsfuldt? Fx hvornår hjælper du dine klassekamerater eller din familie?</strong><br/><br/>
		<strong>Hvornår gør du noget sammen med andre?</strong>`,
		groupText: null,
		icons: ['toolbox'],
		slides: [
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskasse'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
		],
	},
];


export {
	modulePages
};